module.exports = __webpack_public_path__ + "img/IMG-20200609-WA0002.7b39e4de.jpg";